<section class="mb-5">
	<h3>Theme Colors</h3>
	<div class="row">
		@for (themeColor of themeColors; track themeColor) {
			<div class="col-3">
				<div class="bg-{{ themeColor.key }}" [style.height]="boxHeight"></div>
				<div>${{ themeColor.key }}: {{ getVarValue(themeColor.key) }}</div>
			</div>
		}
	</div>
</section>
<section class="mb-5">
	<h3>Color Definitions</h3>
	<div class="row">
		@for (color of colorDefinitions; track color) {
			<div class="col-3">
				<div [style.background-color]="getVarValue(color.key)" [style.height]="boxHeight"></div>
				<div>${{ color.key }}: {{ getVarValue(color.key) }}</div>
			</div>
		}
	</div>
</section>
<section class="mb-5">
	<h3>Gray Scale</h3>
	<div class="row">
		@for (gray of grayScale; track gray) {
			<div class="col-3">
				<div class="bg-{{ gray.key }}" [style.height]="boxHeight"></div>
				<div>${{ gray.key }}: {{ getVarValue(gray.key) }}</div>
			</div>
		}
	</div>
</section>

<section class="mb-5">
	<h3>Theme Colors Hover</h3>
	<div class="row">
		@for (themeColor of themeColors; track themeColor) {
			<div class="col-3">
				<div class="bg-{{ themeColor.key }}-hover" [style.height]="boxHeight"></div>
				<div>${{ themeColor.key }}: {{ getVarValue(themeColor.key) }}</div>
			</div>
		}
	</div>
</section>

<section class="mb-5">
	<h3>Gray Scale Hover</h3>
	<div class="row">
		@for (gray of grayScale; track gray) {
			<div class="col-3">
				<div class="bg-{{ gray.key }}-hover" [style.height]="boxHeight"></div>
				<div>${{ gray.key }}: {{ getVarValue(gray.key) }}</div>
			</div>
		}
	</div>
</section>
